// src/pages/common/COM201F1.jsx
import React, {useEffect, useState} from 'react';

import DataGrid from "components/DataGrid/DataGrid"
import {postData} from "utils/TransactionUtil";
import Chart1 from "components/Chart/Chart1";
import Button from "../../components/Button/Button";
import style from './COM201F1.module.scss'



const COM201F1 = () => {
    //Reg 카운트
    const [rowsRegData, setRowsRegData] = useState([]);
    const [colsRegSetting, setColsRegSetting] = useState([
        { key: 'hsptNm',    name: '기관명',   width: '40%', cellClass: 'align_center'},
        { key: 'reg1Cnt',    name: '등록건수',   width: '30%', cellClass: 'align_cent',
            renderCell: ({ row }) => row.reg1Cnt ? Number(row.reg1Cnt).toLocaleString() : "-"},
        { key: 'reg2Cnt',    name: '연구 완료건수',   width: '30%', cellClass: 'align_cent',
            renderCell: ({ row }) => row.reg2Cnt ? Number(row.reg2Cnt).toLocaleString() : "-"},
    ]);
    const [chartData, setChartData] = useState([
        //{ name: "", 등록건수: 0, 완료건수: 200 }
    ]);

    //Form load
    useEffect(() => {
        getMainList();
    }, []);


    const buttonClick_regUpdate = () => {
        getMainList();
    }

    //공지사항 조회
    async function getMainList(){
        const resData = await postData("/REW/getFrontRegStatus", {});
        setRowsRegData(resData);

        const transObj = resData.map(item => ({
            name: item.hsptNm,
            등록건수: item.reg1Cnt,
            완료건수: item.reg2Cnt,
        }));
        setChartData(transObj);
    }



    return(
        <main className={style.main_wrap}>
            <br/>
            <div style={{display:"flex"}}>
                <h3 className={style.dashItem__title} style={{marginTop: "20px", marginLeft: "10px"}}>
                    기관별 등록/완료 건수 현황</h3>
                <div style={{marginTop:"15px", marginLeft:"20px"}}>
                    <Button variant="Secondary" size="md" addStyle={{width: "80px", height: "35px"}}
                            onClick={() => buttonClick_regUpdate()}> 새로고침</Button>
                </div>

            </div>


            <div style={{padding: "20px"}}>
                <Chart1 data={chartData}/> {/* 데이터 props로 전달 */}
            </div>
            <div style={{paddingLeft: "20%", paddingRight: "20%", height:'30%'}}>
                <DataGrid
                    cols={colsRegSetting}
                    rows={rowsRegData}
                    size='md'
                    headerRowHeight={40}
                    rowHeight={37}
                    isRowColorful={false}
                />
            </div>

        </main>
    )
}
export default COM201F1;
